/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import './Home.scss';
import cn from 'classnames';
import background from 'assets/images/home_background.jpg';
import SearchInput from 'components/WpInput';
import { capitalize } from 'utils/string';
import ImageWithLoader from 'components/ImageWithLoader';
import Spinner from 'components/Spinner';
import { imageFit } from 'utils/cloudinaryHelper';
import Wrapper from 'components/Wrapper';

const CategoryCard = ({ title, image, onClick }) => (
    <div className='Home__card' onClick={onClick}>
        <ImageWithLoader imgUrl={imageFit(image, 220)} name={title} />
        <span>{title}</span>
    </div>);

const ProductCard = ({ title, image, onClick }) => (
    <div className='Home__card Home__card--product' onClick={onClick}>
        <ImageWithLoader imgUrl={imageFit(image, 300)} name={title} />
        <span>{title}</span>
    </div>);

const RoomCard = ({ title, image, onClick }) => (
    <div className={cn(['Home__card', 'Home__card--room'])} onClick={onClick}>
        <ImageWithLoader imgUrl={imageFit(image, 300)} name={title} />
        <span>{title}</span>
    </div>);

const Home = ({
    categoryTypes,
    rooms,
    navigateToRoom,
    navigateToCategoryDetails,
    navigateToSearchPage,
    popularProducts,
    navigateToProductPage,
    isLoading
}) => {
    return (
        <div className='Home'>
            <div className='Home__header'>
                <img className='Home__header_background' alt='header' src={background} />
                <Wrapper>
                    <div className='Home__header_content' >
                        <h1>Products</h1>
                        <h2>Designed with comfort and safety in mind for clients and carers alike. </h2>
                        <div className='Home__header_content_input-wrapper'>
                            <SearchInput
                                onChange={(text) => navigateToSearchPage({ text })}
                                placeholder='Search Products' />
                        </div>
                    </div>
                </Wrapper>
            </div>
            <div className='Home__content'>
                <Wrapper>
                    {isLoading ? <div className='Home__loading' >
                        <Spinner color='#fff' />
                    </div> : <>
                        {/* Explore By Type */}
                        <div className='Home__content_section'>
                            <div className='Home__content_section_wrapper'>
                                <h2>Explore By Type</h2>
                            </div>

                            <div className='Home__content_section_cards'>
                                {categoryTypes.map(({ name, id, image_url, slug }) =>
                                    <CategoryCard
                                        key={id}
                                        title={capitalize(name)}
                                        image={image_url}
                                        onClick={() => navigateToCategoryDetails({ categoryName: slug })} />
                                )}
                            </div>
                        </div>

                        {/* Explore By Rooms */}
                        <div className='Home__content_section'>
                            <h2 className='Home__content_section--white'>Explore By Rooms</h2>
                            <div className='Home__content_section_cards'>
                                {rooms.map(({ name, id, image_url }) =>
                                    <RoomCard
                                        key={id}
                                        title={name}
                                        image={image_url}
                                        onClick={() => navigateToRoom({ roomName: name })} />
                                )}
                            </div>
                        </div>

                        <div className='Home__content_section'>
                            <div className='Home__content_section_wrapper'>
                                <h2 className='Home__content_section--white'>Most Popular Products</h2>
                            </div>

                            <div className='Home__content_section_cards'>
                                {popularProducts.map(item => <ProductCard
                                    key={item.id}
                                    title={item.name}
                                    onClick={() => navigateToProductPage(item.slug)}
                                    image={item.medias && item.medias.image && item.medias.image[0].url} />)}
                            </div>
                        </div>
                    </>}
                </Wrapper>
            </div>
        </div>
    );
};

ProductCard.propTypes = {
    title: PropTypes.string,
    image: PropTypes.string,
    onClick: PropTypes.func
};

CategoryCard.propTypes = {
    title: PropTypes.string,
    image: PropTypes.string,
    onClick: PropTypes.func
};

RoomCard.propTypes = {
    title: PropTypes.string,
    image: PropTypes.string,
    onClick: PropTypes.func

};

Home.propTypes = {
    categoryTypes: PropTypes.array,
    rooms: PropTypes.array,
    navigateToRoom: PropTypes.func.isRequired,
    navigateToCategoryDetails: PropTypes.func.isRequired,
    navigateToSearchPage: PropTypes.func.isRequired,
    navigateToProductPage: PropTypes.func.isRequired,
    popularProducts: PropTypes.array,
    isLoading: PropTypes.bool
};

export default Home;
